import { Routes } from '@angular/router';
import { AuthGuard, setPasswordGuard } from 'libs/auth/src/public-api';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/report-incident',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    loadComponent: () =>
      import('libs/layouts/src/public-api').then((m) => m.AuthLayoutComponent),
    children: [
      {
        path: 'login',
        loadComponent: () =>
          import('libs/auth/src/public-api').then((m) => m.LoginComponent),
      },
      {
        path: 'register',
        loadComponent: () =>
          import('libs/auth/src/public-api').then((m) => m.RegisterComponent),
      },
      {
        path: 'forgot-password',
        loadComponent: () =>
          import('libs/auth/src/public-api').then(
            (m) => m.ForgotPasswordComponent,
          ),
      },
      {
        path: 'password-reset',
        loadComponent: () =>
          import('libs/auth/src/public-api').then(
            (m) => m.ResetPasswordComponent,
          ),
      },
      {
        path: 'set-password',
        canActivate: [setPasswordGuard],
        loadComponent: () =>
          import('libs/auth/src/public-api').then(
            (m) => m.SetPasswordComponent,
          ),
      },
      { path: '**', redirectTo: 'login' },
    ],
  },
  {
    path: '',
    loadComponent: () =>
      import('./layout/private-layout/private-layout.component').then(
        (m) => m.PrivateLayoutComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'report-incident',
        pathMatch: 'full',
      },
      {
        path: 'report-incident',
        loadChildren: () =>
          import('libs/feature/report-incident/src/public-api').then(
            (m) => m.reportIncidentRoutes,
          ),
      },
      {
        path: 'reports',
        loadChildren: () =>
          import('./feature/submitted-forms/submitted-forms.routes').then(
            (m) => m.default,
          ),
      },
      // Pre-split links to the avoided listing keep working.
      {
        path: 'avoided-reports/:id',
        redirectTo: 'reports/avoided/:id',
      },
      {
        path: 'avoided-reports',
        redirectTo: 'reports/avoided',
      },
      {
        path: 'profile',
        loadChildren: () =>
          import('libs/feature/update-profile/src/public-api').then(
            (m) => m.updateProfileRoutes,
          ),
      },
      {
        path: 'not-found',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('libs/feature/not-found/src/public-api').then(
            (m) => m.notFoundRoutes,
          ),
      },
      {
        path: '**',
        redirectTo: '',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];
